import { render, staticRenderFns } from "./MovedNotice.vue?vue&type=template&id=bb6d0812&scoped=true"
import script from "./MovedNotice.vue?vue&type=script&lang=js"
export * from "./MovedNotice.vue?vue&type=script&lang=js"
import style0 from "./MovedNotice.vue?vue&type=style&index=0&id=bb6d0812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6d0812",
  null
  
)

export default component.exports